module.exports = __webpack_public_path__ + "img/131.24db42e9.jpg";